import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "services/redux/store";
import { SVG } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type ProfileHeaderProps = CustomComponentProps & {
    // handleOpenProfile: Function;
    setOpenIdirectModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const ProfileHeader = ({
    setOpenIdirectModal,
    className,
    style
}: ProfileHeaderProps) => {
    const { avatar, cover, name, userName, country, about } = useSelector(
        (state: RootState) => state.account
    );
    const [follow, setFollow] = useState(false);

    return (
        <div className={`profile-header ${className}`} style={style}>
            <div className="cover-bg">
                <img className="cover-image" src={cover} alt="" />
                <div className="avatar">
                    <img
                        id="user-avatar"
                        className="avatar-image"
                        src={avatar}
                        alt=""
                    />
                </div>
                <div className="cover-overlay"></div>
            </div>

            <div className="custom-profile-subheader pt-20 pb-20 pr-10 pl-10">
                <div className="subheader-middle first-subheader">
                    <div className="d-flex flex-j-start flex-a-center gap-5">
                        <SVG
                            svg="map-pointer"
                            size={16}
                            className="blue-white-svg"
                        />
                        <span>{country.label}</span>
                    </div>
                    <span>Joined: March 2024</span>
                </div>
                <div className="subheader-middle">
                    <h2 className="white-text">{name}</h2>
                    <span>@{userName}</span>
                </div>
            </div>

            <div className="profile-about pb-20 pr-10 pl-10">
                <p className="momeento-p">{about}</p>
            </div>

            <div className="profile-meta d-flex flex-j-between flex-a-start gap-5  pr-10 pl-10 pb-20">
                {/* followers */}
                <Link
                    to={`/profile/${userName}/followers/2`}
                    className="profile-meta-item"
                >
                    <SVG
                        svg="user-double-check"
                        size={24}
                        className="blue-white-svg"
                    />
                    <span className="momeento-p black-text white-text">
                        Followers
                    </span>
                    <span className="profile-meta-number black-text white-text">
                        999
                    </span>
                </Link>
                {/* indirect followers */}
                <div
                    className="profile-meta-item"
                    onClick={() => setOpenIdirectModal(true)}
                >
                    <SVG
                        svg="curved-arrow"
                        size={24}
                        className="blue-white-svg"
                    />
                    <span className="momeento-p">Indirect Followers</span>
                    <span className="profile-meta-number">25 K</span>
                </div>
                {/* follow */}
                <div
                    className="profile-meta-item"
                    onClick={() => setFollow(() => !follow)}
                >
                    <SVG
                        svg={`${follow ? "followed" : "follow"}`}
                        size={24}
                        className="blue-white-svg follow-user-svg transition-svg"
                    />
                    <span className="momeento-p">
                        {follow ? "Followed" : "Follow"}
                    </span>
                </div>
                {/* message */}
                <div className="profile-meta-item">
                    <SVG
                        svg="message-circle"
                        size={24}
                        className="blue-white-svg"
                    />
                    <span className="momeento-p">Message</span>
                </div>
            </div>
        </div>
    );
};

export default ProfileHeader;
